'use client';
// ImageLightbox + tag-search ordering (14/10/26): photos whose TAGS match the visitor's search come first. Neutral order without a search context.
import { useMemo } from 'react';
import ImageLightbox from './ImageLightbox';
import { useTagOrder, tagLabel } from './tagContext';

type LbProps = React.ComponentProps<typeof ImageLightbox>;

export default function TagImageLightbox({ proId, images, imageTags, ...rest }: LbProps & { proId: number }) {
  const { order, reset } = useTagOrder(proId);
  const { list, matched } = useMemo(() => {
    if (!order) return { list: images, matched: 0 };
    const set = new Set(images); const first = order.gallery.filter((u) => set.has(u));
    const f = new Set(first);
    return { list: [...first, ...images.filter((u) => !f.has(u))], matched: first.length };
  }, [order, images]);
  const tagsFor = useMemo(() => { if (!imageTags) return undefined; const m = new Map(images.map((u, i) => [u, imageTags[i] || []] as const)); return list.map(u => m.get(u) || []); }, [imageTags, images, list]);
  return (
    <>
      {order && matched > 0 && (
        <div data-tag-chip="gallery" className="flex items-center gap-2 mb-2 text-xs" style={{ color: '#1d4ed8' }}>
          <span className="px-2.5 py-1 rounded-full" style={{ background: '#eff6ff', border: '1px solid #bfdbfe' }}>מציג קודם: {tagLabel(order)} ({matched})</span>
          <button type="button" onClick={reset} className="underline" style={{ color: '#64748b', minHeight: 32 }}>סדר רגיל</button>
        </div>
      )}
      <ImageLightbox images={list} imageTags={tagsFor} {...rest} />
    </>
  );
}
